module.exports = __webpack_public_path__ + "static/media/3-10.26c6e8b2.webp";